const EVENT_NAME_MAP = {
  THIRD_ORDER_VERSION: 'G_ThirdOrder_Version',
  THIRD_ORDER_TO_STUDENT_CENTER_RESERVE_CLICK: 'G_ThirdOrder_ToStudentCenter_Reserve_Click',
  THIRD_ORDER_TO_STUDENT_CENTER_RESERVE_CLICK_USER: 'G_ThirdOrder_ToStudentCenter_Reserve_ClickUser',
  THIRD_ORDER_TO_STUDENT_CENTER_CLICK: 'G_ThirdOrder_ToStudentCenter_Click',
  THIRD_ORDER_TO_STUDENT_CENTER_CLICK_USER: 'G_ThirdOrder_ToStudentCenter_ClickUser',
  G_LOADING: 'G_LoadingDuration',
  THIRD_ORDER_LONG_PRESS_QR_Code: 'G_QR_Code',
};

export default {
  EVENT_NAME_MAP,
};
